export default __webpack_public_path__ + "static/media/vec.0d043109.png";